import { useMemo } from "react";
import { GLOBAL_CONSTANTS } from "../../../constants/constants"
import { formatDate, formatCurrency } from "../../../helpers/helpers"
import { Table, Typography } from "antd"
import { TABLE_PAGINATION } from "../../../constants/tableConfig";

const { Text } = Typography;

const DealLevelSettlement = ({ deal }) => {
    const columns = useMemo(() => [
        {
            title: "Transaction Id",
            dataIndex: "transactionId",
            key: "transactionId",
            render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
        },
        {
            title: "Transaction Date",
            dataIndex: "transactionDate",
            key: "transactionDate",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatDate(text)}</Text>,
        },
        {
            title: "Particulars",
            dataIndex: "particulars",
            key: "particulars",
            render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
        },
        {
            title: "Credit",
            dataIndex: "credit",
            key: "credit",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text || 0)}</Text>,
        },
        {
            title: "Interest",
            dataIndex: "interest",
            key: "interest",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text || 0)}</Text>,
        },
        {
            title: "Penalty",
            dataIndex: "penalty",
            key: "penalty",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text || 0)}</Text>,
        },
        {
            title: "Balance",
            dataIndex: "balance",
            key: "balance",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text || 0)}</Text>,
        },
        {
            title: "Karncy Payout",
            dataIndex: "karncyPayout",
            key: "karncyPayout",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text || 0)}</Text>,
        },
        {
            title: "Investor Payout",
            dataIndex: "investorPayout",
            key: "investorPayout",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text || 0)}</Text>,
        },
        {
            title: "Business Payout",
            dataIndex: "businessPayout",
            key: "businessPayout",
            render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text || 0)}</Text>,
        },
    ], []);

    return (
        <Table
            columns={columns}
            dataSource={deal}
            rowKey="transactionId"
            bordered
            scroll={{ x: "max-content" }}
            pagination={TABLE_PAGINATION}
            className="deal-level-funding-table"
        />
    );
};

export default DealLevelSettlement;
